<template>
    <div style="max-width: 1200px;" class="mx-auto">
        <h3 class="text-center">Amortization Schedule - Annual Projections</h3>
        <div class="my-4">NOTE: Actual interest charges and property value projections may vary from amounts shown.
            Available credit will be less than projected if funds are withdrawn from the line of credit
            (LOC). Additionally, the Payments column below reflects annual totals of monthly payments from or to the
            Borrower and payments from a Life Expectancy Set Aside (for property
            taxes and hazard insurance), if applicable.
        </div>

        <v-simple-table dense class="cashflow-table">
            <colgroup>
                <col>
                <col>
                <col class="col-blue">
                <col class="col-blue">
                <col class="col-blue">
                <col class="col-blue">
                <col class="col-yellow">
                <col class="col-yellow">
                <col class="col-yellow">
                <col class="col-yellow">
            </colgroup>
            <thead>
                <tr>
                    <th class="text-center" :colspan="2"></th>
                    <th class="text-center" :colspan="4">Annual Totals</th>
                    <th class="text-center" :colspan="4">End of Year Projections</th>
                </tr>
                <tr>
                    <th class="text-left">End of Year</th>
                    <th class="text-left">Age</th>
                    <th class="text-right">Payments</th>
                    <th class="text-right">MIP</th>
                    <th class="text-right">Rate</th>
                    <th class="text-right">Interest</th>
                    <th class="text-right">Loan Balance</th>
                    <th class="text-right">Line of Credit</th>
                    <th class="text-right">Property Value</th>
                    <th class="text-right">Equity</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(row, i) in rows" :key="row.year">
                    <td>{{ i + 1 }}</td>
                    <td>{{ row.age }}</td>
                    <td class="text-right">{{ formatMoney(row.drawsAndPayments) }}</td>
                    <td class="text-right">{{ formatMoney(row.MIP) }}</td>
                    <td class="text-right">{{ formatPercentage(row.rate) }}</td>
                    <td class="text-right">{{ formatMoney(row.interest) }}</td>
                    <td class="text-right">{{ formatMoney(row.loanBalance) }}</td>
                    <td class="text-right">{{ formatMoney(row.lineOfCredit) }}</td>
                    <td class="text-right">{{ formatMoney(row.propertyValue) }}</td>
                    <td class="text-right">{{ formatMoney(row.equity) }}</td>
                </tr>
            </tbody>

        </v-simple-table>
    </div>
</template>

<script>
import helpers from '../../helpers';

export default {
    methods: {
        formatMoney: helpers.formatMoney,
        formatPercentage: helpers.formatPercentage
    },
    computed: {
        rows() {
            return this.$store.state.amortCompAndTALC.data.annualProjectionsNotHUD || []
        },
    },
};
</script>

<style>
/* not scoped? drop :deep() */
.cashflow-table col.col-yellow {
    background-color: hsla(48, 100%, 50%, .12);
}

.cashflow-table col.col-blue {
    background-color: hsla(199, 100%, 40%, .10);
}
</style>
